// extracted by mini-css-extract-plugin
export default {"modal":"AddTabModal_modal__-jTU1","content":"AddTabModal_content__9A1M2","btn":"AddTabModal_btn__jo+8F","name":"AddTabModal_name__ERZPm"};